import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=14a72b9d&"
import script from "./SharingTab.vue?vue&type=script&lang=js&"
export * from "./SharingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports